import React from "react";

const Java_Syntax_Statements = () => {
  return (
    <div>
      <h1>Java Syntax Statements</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Syntax Statements in Java.</p>
    </div>
  );
};

export default Java_Syntax_Statements;
